// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__1KAZ6","col":"styles_col__3WoO4"};